export default __webpack_public_path__ + "static/media/4cB.452d651f.png";